















import { defineComponent } from '@vue/composition-api';
import { SUBMIT_ERROR_STATUS } from '../const';

export default defineComponent({
  props: {
    status: {
      type: Number,
      default: 0,
    },
    statusTitle: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      SUBMIT_ERROR_STATUS,
    };
  },
});
